import React from 'react';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1429">
      <Navigation data-id="element-1430" />

      <main data-id="element-1431">
        <Hero data-id="element-1432" />
        <WhyUs data-id="element-1433" />
        <Services data-id="element-1434" />
        <FAQ data-id="element-1435" />
        <Testimonials data-id="element-1436" />
        <Consultation data-id="element-1437" />
      </main>

      <Footer data-id="element-1438" />
      <CookieBanner data-id="element-1439" />
      <FloatingContact data-id="element-1440" />
    </div>;
}